import React from "react";
import { FiEye, FiEyeOff, FiColumns } from "react-icons/fi";

export default function ColumnToggle({ columns, hiddenCols, onToggle }) {
  const [open, setOpen] = React.useState(false);

  return (
    <div style={{ position: "relative" }}>
      <button onClick={() => setOpen(!open)} style={{
        display: "flex", alignItems: "center", gap: 4, padding: "7px 12px",
        border: "1px solid #e2e8f0", borderRadius: 7, background: "#fff",
        color: "#64748b", fontFamily: "inherit", fontSize: 12, cursor: "pointer",
      }}>
        <FiColumns size={14} /> أعمدة
        {hiddenCols.length > 0 && <span style={{
          background: "#ef4444", color: "#fff", fontSize: 9, padding: "0 4px", borderRadius: 10,
        }}>{hiddenCols.length}</span>}
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "100%", left: 0, zIndex: 50,
          background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8,
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)", padding: 8, minWidth: 200,
          maxHeight: 350, overflowY: "auto", direction: "rtl",
        }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", padding: "4px 8px", marginBottom: 4 }}>
            إظهار/إخفاء الأعمدة
          </div>
          {columns.map(col => {
            const hidden = hiddenCols.includes(col.key);
            return (
              <label key={col.key} style={{
                display: "flex", alignItems: "center", gap: 6, padding: "5px 8px",
                cursor: "pointer", borderRadius: 4, fontSize: 12,
                background: hidden ? "#fef2f2" : "transparent",
              }}>
                <input type="checkbox" checked={!hidden} onChange={() => onToggle(col.key)}
                  style={{ width: 14, height: 14, accentColor: "#2563eb" }} />
                {hidden ? <FiEyeOff size={12} color="#ef4444" /> : <FiEye size={12} color="#22c55e" />}
                <span>{col.label}</span>
              </label>
            );
          })}
          {hiddenCols.length > 0 && (
            <button onClick={() => hiddenCols.forEach(k => onToggle(k))} style={{
              display: "block", width: "100%", marginTop: 4, padding: "5px 8px",
              border: "none", background: "#eff6ff", color: "#2563eb",
              fontFamily: "inherit", fontSize: 11, borderRadius: 4, cursor: "pointer",
            }}>إظهار الكل</button>
          )}
        </div>
      )}
    </div>
  );
}
